import(/* webpackMode: "eager", webpackExports: ["LinkInternal"] */ "/vercel/path0/packages/ui/dist/components/link.js");
